import { render, staticRenderFns } from "./HrFeedLogTablePage.vue?vue&type=template&id=ef8ff37e"
import script from "./HrFeedLogTablePage.vue?vue&type=script&lang=js"
export * from "./HrFeedLogTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports